<template>
  <div class="ain-Wrapper">
    <AddOkrButton
      :id="`ani-Trigger-${uniqId}`"
      :disable-margin="disableMargin || simplify"
      :disabled="disabled"
      :is-active="showDropdown"
      :simplify="simplify"
    >
      <slot v-if="$slots.default" />
    </AddOkrButton>

    <DropdownMenu
      :disabled="disabled"
      :follow-cursor="followCursor"
      :items="dropdownOptions"
      :offset="[0, 0]"
      :show="showDropdown"
      :to-selector="`#ani-Trigger-${uniqId}`"
      :type="DROPDOWN_MENU_TYPES.DEFAULT_NEXT"
      append-to="parent"
      preferred-position="bottom-end"
      @update:show="showDropdown = $event"
      @item-click="onOptionClick"
    />
  </div>
</template>

<script setup>
import { ref, useId } from 'vue'

import { DROPDOWN_MENU_TYPES } from '@/utils/components-configurations/dropdown-menu'

import AddOkrButton from '@/components/objectives/forms/AddOkrButton'
import DropdownMenu from '@/components/ui/DropdownMenu/DropdownMenu'

defineOptions({
  name: 'AddNestedItem'
})

const uniqId = useId()

const showDropdown = ref(false)

defineProps({
  dropdownOptions: {
    type: Array,
    required: true
  },

  followCursor: {
    type: [String, Boolean],
    default: 'initial'
  },

  simplify: {
    type: Boolean
  },

  disableMargin: {
    type: Boolean
  },

  disabled: {
    type: Boolean
  }
})

const emit = defineEmits(['on-option-click'])

const onOptionClick = id => {
  emit('on-option-click', id)
}
</script>

<style lang="scss" scoped></style>
